// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"358":"live-streaming","393":"study-ai","594":"about","626":"study","977":"medical-code"}[chunkId] || chunkId) + "." + {"45":"dd31fe0c","209":"2df8ad69","358":"6bf03976","393":"34080a91","495":"e920b993","594":"b84a1972","626":"9cead15e","922":"c9d81b80","977":"e14756db"}[chunkId] + ".js";
};